module.exports = __webpack_public_path__ + "static/img/14.8b43789.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/sp/14.png
// module id = /RkZ
// module chunks = 0